import Pagination from "components/Common/newPagination";
import React, { Suspense, useState, useEffect } from "react";
import songServices from "./songServices";
import ViewContractReleaseAsset from "components/MetaData/Release/ViewContractReleaseAsset";
import ContractAssetLink from "../contractAssetLink";
import { SongSplitsSearch } from "../Song/SongSplitsSearch";

export default function AssociatedSongs(contractDetails: any) {

    const [totalRows, setTotalRows] = useState(0);
    const [AssociatedSongs, initAssociatedSongs] = useState<any[]>([]);
    let [songSplitsSearch, setsongSplitsSearch] = useState<any>([]);
    let [opensongSplitsSearch, setopensongSplitsSearch] = useState(false);
    let [ContractAssetLinkOpen, setContractAssetLinkOpen] = useState(false);
    let [viewContract, setviewContract] = useState(false);
    let [viewContractSelect, setviewContractSelect] = useState<any>([]);

    const Data: any = {
        pageSize: 10,
        pageNumber: 1,
        contractRefNum: contractDetails?.contractDetails?.contractRefNum
    }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;

        getAffilate()
    }

    useEffect(() => {
        getAffilate()
    }, []);

    const getAffilate = () => {

        songServices.AssociatedSongs(Data).then((res) => {
            console.log(res);
            initAssociatedSongs(res)
            setTotalRows(res[0].totalRows)
        })
    };

    const ViewContractReleaseChange = (e: any) => {
        viewContract = false
        setviewContract(viewContract)
    }

    const onChangContractAssetLink = (e: any) => {
        console.log(e)
        ContractAssetLinkOpen = false;
        setContractAssetLinkOpen(ContractAssetLinkOpen)
    }
    const closeSongSplitsSearch = (e: any) => {
        opensongSplitsSearch = false
        setopensongSplitsSearch(opensongSplitsSearch)
    }

    const exportFullListing = () => {
        songServices.AssociatedSongExport(Data)
    }

    return (

        <div className="ws-12">
            <div className="box-content p0">

                <div className="ws-12 pm">
                    <h3 className="capitalize mb pull-left ws-5 pt">  Associated song ({totalRows})  </h3>
                    <button className="icon-btn info pull-right height35" onClick={exportFullListing}>  <i className="icon-download"></i></button>
                    <button className="icon-btn edit pull-right mb height35" ng-click="openTrack()"> Add New song</button>
                    <button className="icon-btn edit pull-right mb height35" onClick={() => setContractAssetLinkOpen(true)}> Link song</button>
                </div>

                {(totalRows > 0) && <table className="newTable">
                    <thead>
                        <tr className="forceSingleLine">
                            <th style={{width : "120px"}}>Song Ref</th>
                            <th>Song Title</th>
                            <th>Song Main Composer</th>
                            <th>Song Main Publisher</th>
                            <th>ISWC</th>
                            <th style={{width : "135px"}}>%Split</th>
                            <th style={{width : "110px"}}>Operation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            AssociatedSongs.map(post => (
                                <tr>
                                    <td>{post?.songRef}
                                        <button className="icon-btn info btn-xs pull-right" onClick={() => { setviewContract(true); setviewContractSelect(post) }}>
                                            <i className="icon-price-list"></i>
                                        </button>
                                    </td>
                                    <td>{post?.songName}</td>
                                    <td>{post?.songMainComposer}</td>
                                    <td>{post?.songMainPublisher}</td>
                                    <td>{post?.intStdWorkCode}</td>
                                    <td>
                                        <span className={post?.publishingSplit > 100 || post?.publishingSplit == 0 ? "text-bold danger " : "text-bold success"}>{post?.publishingSplit?.toFixed(2)}</span>
                                        <button className="icon-btn edit width70 pull-right" onClick={() => { setopensongSplitsSearch(true); setsongSplitsSearch(post); }}>Splits  </button>
                                    </td>
                                    <td>
                                        <button className="icon-btn edit">
                                            <i className="icon-edit"></i>
                                        </button>

                                        <button className="icon-btn delete">
                                            <i className="icon-trashcan"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        }

                    </tbody>
                </table>}
                {
                    (() => {
                        if (totalRows > 1 && totalRows > 10) {
                            return <Pagination onPageChange={handleNameOnChange} totalRow={totalRows} />
                        }

                        if (totalRows === 0) {
                            return <div className="alert alert-info mt mrl mbl"> No data to display</div>
                        }
                    })()
                }

            </div>

            {
                (() => {

                    if (viewContract) {
                        return <ViewContractReleaseAsset ViewContractReleaseChange={ViewContractReleaseChange} type="song"
                            viewContract={viewContract} viewContractSelect={viewContractSelect} />
                    }

                    if (ContractAssetLinkOpen) {
                        return <ContractAssetLink onChangContractAssetLink={onChangContractAssetLink} ContractAssetLinkOpen={ContractAssetLinkOpen} type="Songs" contractDetails={contractDetails?.contractDetails} />
                    }

                    if (opensongSplitsSearch) {
                        return <SongSplitsSearch opensongSplitsSearch={opensongSplitsSearch} data={songSplitsSearch} closeSongSplitsSearch={closeSongSplitsSearch} />
                    }

                })()
            }

        </div>

    )
}